import { FEATURE_FLAGS_NAMESPACE } from '../../config/settings/constants'

/**
 * Gets the features flags.
 */
const getFeaturesFlags = entries =>
  Object.entries(entries || {})
    .filter(([key]) => key.includes('REACT_APP_FEATURE_FLAG_'))
    .reduce((dictionary, [key, value]) => {
      const formattedKey = key.replace('REACT_APP_FEATURE_FLAG_', '').replace(/_/g, '-').toLowerCase()
      return {
        ...dictionary,
        [`${FEATURE_FLAGS_NAMESPACE}/${formattedKey}`]: value === true || value === 'true'
      }
    }, {})

export default getFeaturesFlags
